// extracted by mini-css-extract-plugin
module.exports = {"container":"e_tmb","widget":"e_umb","title":"e_vmb","msrp":"e_wmb","separator":"e_xmb","textBadge":"e_ymb"};